import {exportBonusGroupStats} from "./query/exportBonusGroupStats";

export const bonusGroupStatsClient = {
  query: {
    exportBonusGroupStats: exportBonusGroupStats
  },
};
